const features = [
  {
    icon: 'ri-time-line',
    title: 'Save Research Time',
    description: 'Find products faster with organized spreadsheet collections. No more endless scrolling through thousands of listings.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Better Product Discovery',
    description: 'Explore popular categories and trending items curated by experienced shoppers who know what to look for.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Smarter Decisions',
    description: 'Compare prices, shipping options, and product quality across different categories before making a purchase.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Friendly',
    description: 'Learn how Basetao works step by step with clear tutorials and guides designed for first-time users.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Verified Information',
    description: 'Every product listing and guide is regularly updated with accurate, verified information from real user experiences.',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Shipping Insights',
    description: 'Get detailed shipping cost breakdowns, delivery time estimates, and carrier comparisons for your region.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100/70 rounded-full">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            Why Thousands of Shoppers Trust Basetao Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            We make Basetao shopping easier, faster, and more informed with our comprehensive product research system.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/40 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}